import { useState } from "react";
import api from "../../api/axios";

const PARENT_CATEGORY_OPTIONS = [
  { value: "", label: "Select Category" },
  { value: "Accessories", label: "Accessories" },
  { value: "Office Components", label: "Office Components" },
  { value: "Gaming", label: "Gaming" },
  { value: "Desktop & Server", label: "Desktop & Server" },
  { value: "Gadgets", label: "Gadgets" },
  { value: "Home Appliance", label: "Home Appliance" },
];

export default function CategoryCreateModal({ onClose, onSuccess }) {
  const [form, setForm] = useState({
    parent: "",
    name: "",
    description: "",
    is_active: true,
  });

  const handleSubmit = async () => {
    if (!form.name) {
      alert("Product Category Name is required");
      return;
    }

    await api.post("companyblog/admin/categories/create/", {
      parent: form.parent || null,
      name: form.name,
      description: form.description,
      is_active: form.is_active,
    });

    onSuccess();
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-dialog modal-lg">
        <div className="modal-content p-4">
          <h5 className="mb-4">Create Product Category</h5>

          <div className="row">
            <div className="col-md-6">
              <label>Select a category *</label>
              <select
                className="form-control"
                value={form.parent}
                onChange={(e) =>
                  setForm({ ...form, parent: e.target.value })
                }
              >
                {PARENT_CATEGORY_OPTIONS.map((opt) => (
                  <option key={opt.label} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6">
              <label>Product Category Name *</label>
              <input
                className="form-control"
                placeholder="Select Category Name"
                value={form.name}
                onChange={(e) =>
                  setForm({ ...form, name: e.target.value })
                }
              />
            </div>
          </div>

          <div className="mt-3">
            <label>Short Description</label>
            <textarea
              className="form-control"
              rows="3"
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
            />
          </div>

          <div className="mt-3">
            <label>Status</label>
            <div>
              <label className="me-3">
                <input
                  type="radio"
                  checked={form.is_active === true}
                  onChange={() =>
                    setForm({ ...form, is_active: true })
                  }
                />{" "}
                Active
              </label>

              <label>
                <input
                  type="radio"
                  checked={form.is_active === false}
                  onChange={() =>
                    setForm({ ...form, is_active: false })
                  }
                />{" "}
                Inactive
              </label>
            </div>
          </div>

          <div className="mt-4">
            <button className="btn btn-primary" onClick={handleSubmit}>
              Save
            </button>
            <button className="btn btn-secondary ms-2" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
